<template>
  <div class="editable-cell">
    <!-- <div v-if="editable" class="editable-cell-input-wrapper"> -->
    <div class="editable-cell-input-wrapper">
      <!-- <div class="score-input-group" @mouseleave="checkBase"> -->
      <div class="score-input-group">
        <label class="score-name">基础得分：</label>
        <!-- :autoFocus="autoFocus"
          :autoFocus="autoFocus" -->
        <a-input-number
          :maxBase="maxBase"
          :min="0"
          :value="value"
          @change="handleChange"
          @pressEnter="checkBase"
          @blur="checkBase"
        />
      </div>
      <!-- <div class="score-input-group" @mouseleave="checkExtra"> -->
      <div class="score-input-group">
        <label class="score-name">额外得分：</label>
        <a-input-number
          :maxExtra="maxExtra"
          :min="0"
          :value="extraValue"
          @change="handleExtraChange"
          @pressEnter="checkExtra"
          @blur="checkExtra"
        />
      </div>
    </div>
    <!-- <div v-else class="editable-cell-text-wrapper">
      <div v-if="evaluationTablePreview" class="score-display-group">
        <div class="score-display">
          <label class="score-name">基础得分：</label>
          <span>{{ value || "0" }}</span>
        </div>
        <div class="score-display">
          <label class="score-name">额外得分：</label>
          <span>{{ extraValue || "0" }}</span>
        </div>
      </div>
      <div v-else class="score-display-group" @mouseenter="edit">
        <div class="score-display">
          <label class="score-name">基础得分：</label>
          <span>{{ value || "0" }}</span>
        </div>
        <div class="score-display">
          <label class="score-name">额外得分：</label>
          <span>{{ extraValue || "0" }}</span>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    text: {
      type: [String, Number],
      default: "0",
    },
    extraText: {
      type: [String, Number],
      default: "0",
    },
    maxBase: {
      type: Number,
      default: 0,
    },
    maxExtra: {
      type: Number,
      default: 0,
    },
    evaluationTablePreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.text.toString(),
      extraValue: this.extraText.toString(),
      editable: false,
      // autoFocus: true,
    };
  },
  watch: {
    text(newVal) {
      this.value = newVal.toString();
    },
    extraText(newVal) {
      this.extraValue = newVal.toString();
    },
  },
  methods: {
    handleChange(value) {
      if (value > this.maxBase) {
        this.$message.warn("输入得分超出对应分值,按对应分值最高分评分");
        this.value = this.maxBase;
      } else {
        this.value = value;
      }
    },
    handleExtraChange(value) {
      if (value > this.maxExtra) {
        this.$message.warn("输入得分超出对应分值,按对应分值最高分评分");
        this.extraValue = this.maxExtra;
      } else {
        this.extraValue = value;
      }
    },
    checkBase() {
      //this.editable = false;
      //  console.log("33333");
      this.$emit("onCellChangeBase", this.value);
    },
    checkExtra() {
      //this.editable = false;
      //  console.log("44444");
      this.$emit("onCellChangeExtra", this.extraValue);
    },
    edit(e) {
      // console.log("55555");
      if (!this.editable) {
        // 避免重复触发
        this.editable = true;

        e.stopPropagation();
      }
      // this.editable = true;
      // this.$forceUpdate();
      // e.stopPropagation()
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .editable-cell {
  height: auto;
  min-height: 50px;

  .editable-cell-input-wrapper,
  .score-display-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .score-input-group,
  .score-display {
    display: flex;
    align-items: center;

    .score-name {
      min-width: 80px;
      text-align: right;
      margin-right: 8px;
      font-size: 16px;
    }
  }

  .editable-cell-text-wrapper {
    width: 100%;
    padding: 5px 0;

    .score-display-group {
      cursor: pointer;

      &:hover {
        background-color: #f5f5f5;
      }
    }
  }

  .ant-input-number {
    width: 80px;

    &-handler-wrap {
      display: none;
    }
  }
}
</style>